import { Container, Grid, GridColumn, GridRow } from 'semantic-ui-react';
import styles from './MainPage.module.css';
import Card1 from './Card1';
import Card2 from './Card2';
import Card3 from './Card3';

const MainPage = () => {
    return (
        <>
            <Grid columns='equal'>
                <GridRow only='computer tablet' columns='equal'>
                    <GridColumn className={styles.hero}>
                        <img src="./assets/backbg2.png" style={{ minWidth: 768 }} />
                        <div className={styles.herotext}>
                            <center><h1>Аромат трюфеля удобряет почву - возрождает землю</h1></center>
                            <p></p>
                        </div>
                    </GridColumn>
                </GridRow>
                <GridRow only='mobile'>
                    <GridColumn className={styles.hero}>
                        <img src="./assets/mainpagehero_mobile.jpg" style={{ minWidth: 768 }} />
                        <div>
                            <center><h1> </h1></center>
                            <p></p>
                        </div>
                    </GridColumn>
                </GridRow>
            </Grid>
            <Container className={styles.container}>
                <Grid columns='equal'>
                    <GridRow only='computer tablet' columns='equal'>
                        <GridColumn>
                            <Card1 />
                        </GridColumn>
                        <GridColumn>
                            <Card2 />
                        </GridColumn>
                        <GridColumn>
                            <Card3 />
                        </GridColumn>
                    </GridRow>
                    <GridRow only='mobile'>
                        <GridColumn>
                            <Card1 />
                            <Card2 />
                            <Card3 />
                        </GridColumn>
                    </GridRow>
                </Grid>


            </Container>
        </>);
}

export default MainPage